/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * For all items in the testPart, calculates numeric index of item as the user will see it (=viewPosition):
 * viewPosition is relative to the start of the testPart, and doesn't include informational items.
 * @param {Object} testPart - TestPart object from store
 * @returns {Object.<number, number?>} - dictionary of viewPositions with item.position as a key
 */
export default function getItemViewPositions(testPart) {
    const testPartOffset = testPart.position;
    let infoItemsOffset = 0;
    const viewPositions = {};
    for (const sectionId in testPart.sections) {
        const section = testPart.sections[sectionId];
        for (const itemId in section.items) {
            const item = section.items[itemId];
            let viewPosition;
            if (item.informational) {
                infoItemsOffset += 1;
                viewPosition = null;
            } else {
                viewPosition = item.position - testPartOffset - infoItemsOffset + 1;
            }
            viewPositions[item.position] = viewPosition;
        }
    }
    return viewPositions;
}
